import { FileProviderAriaText } from '../strings.locstring.json';
import { ComputerFileProviderDisplayName } from './LocalComputerFileProviderView.locstring.json';
import loc, { format } from 'owa-localize';
import FileProviderView from './FileProviderView';
import LocalComputerFilePicker from './LocalComputerFilePicker';
import { observer } from 'mobx-react';
import { getIconForFileProvider as getLocalComputerIconCSS } from 'owa-fileprovider-icon';
import { FileSelectionFilter } from 'owa-fileprovider-store';

import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./LocalComputerFileProviderView.scss');

export interface LocalComputerFileProviderViewProps {
    onFilesSelected: (files: File[], fileSelectionFilter: FileSelectionFilter) => void;
    fileSelectionFilter: FileSelectionFilter;
    onLocalComputerClicked: () => void;
}

@observer
export default class LocalComputerFileProviderView extends React.Component<
    LocalComputerFileProviderViewProps,
    {}
> {
    private localComputerFilePicker: LocalComputerFilePicker;

    render() {
        return (
            <div>
                <FileProviderView
                    name={loc(ComputerFileProviderDisplayName)}
                    icon={getLocalComputerIconCSS(ControlIcons.System, styles.computerImage)}
                    onClick={this.onLocalComputerFileProviderClicked}
                    ariaLabel={format(
                        loc(FileProviderAriaText),
                        loc(ComputerFileProviderDisplayName)
                    )}
                />

                <LocalComputerFilePicker
                    ref={ref => (this.localComputerFilePicker = ref)}
                    onFilesSelected={this.onFilesSelected}
                    fileSelectionFilter={this.props.fileSelectionFilter}
                />
            </div>
        );
    }

    private onFilesSelected = (files: File[]) => {
        this.props.onFilesSelected(files, this.props.fileSelectionFilter);
    };

    private onLocalComputerFileProviderClicked = () => {
        this.props.onLocalComputerClicked();
        this.localComputerFilePicker.click();
    };
}
